export default __webpack_public_path__ + "static/media/activity-group-yellow.4d3d09c0.svg";